import { create } from 'zustand'
import { persist } from 'zustand/middleware'

interface SelfAssessmentState {
  step: number
  answers: Record<number, number>
  completed: boolean
}

interface SelfAssessmentActions {
  setAnswer: (questionId: number, score: number) => void
  nextStep: () => void
  prevStep: () => void
  reset: () => void
  setCompleted: () => void
}

export const useSelfAssessmentStore = create<SelfAssessmentState & SelfAssessmentActions>()(
  persist(
    (set) => ({
      step: 1,
      answers: {},
      completed: false,

      setAnswer: (questionId, score) =>
        set((state) => ({ answers: { ...state.answers, [questionId]: score } })),

      nextStep: () => set((state) => ({ step: Math.min(state.step + 1, 8) })),

      prevStep: () => set((state) => ({ step: Math.max(state.step - 1, 1) })),

      reset: () => set({ step: 1, answers: {}, completed: false }),

      setCompleted: () => set({ completed: true }),
    }),
    { name: 'cb_self_assessment' },
  ),
)
